import { render, staticRenderFns } from "./PageBecomeCreator.vue?vue&type=template&id=34a70841&scoped=true&"
import script from "./PageBecomeCreator.vue?vue&type=script&lang=ts&"
export * from "./PageBecomeCreator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a70841",
  null
  
)

export default component.exports